import type { PrimaryFilterId } from '../../filters/types/filters';
import { getDimensionLabel } from '../ChartConfig/utils/dimension-source-options';
import { metricToTitleMap, secondaryDimensionToTitleMap } from './constants';
import type { PositionedItem } from './types/item';
import type { MetricValues } from './types/metric';

const metricLabelOf = (metric: MetricValues): string =>
  metricToTitleMap[metric as keyof typeof metricToTitleMap] ?? metric;

export const getChartTitle = (
  item: PositionedItem,
  primaryFilterId?: PrimaryFilterId
): string => {
  const plot = item.plot ?? {};

  if (
    plot.chartType === 'table' &&
    plot.tableColumns &&
    plot.tableColumns.length > 0
  ) {
    const labels = plot.tableColumns.map((column) => {
      if (column.label) return column.label;
      return column.kind === 'dimension'
        ? getDimensionLabel(column.dimension, primaryFilterId)
        : metricLabelOf(column.metric);
    });
    return labels.join(', ');
  }

  const { defaultMetricOptions, secondaryDimension } = plot;
  const firstMetric = defaultMetricOptions?.[0];
  if (!firstMetric) return '';

  const metricLabel = metricLabelOf(firstMetric);

  if (secondaryDimension) {
    return `${metricLabel} by ${secondaryDimensionToTitleMap[secondaryDimension]}`;
  }
  return metricLabel;
};
